export enum PaymentPlanTypeIds {
    PRIVATE = 1,
    IGSS = 2,
}

export const ORIGINS_EDITABLE_LIST: PaymentPlanTypeIds[] = [
    PaymentPlanTypeIds.PRIVATE,
]